import React from 'react';

import { ReceiptItems, ReceiptItemsProps } from './ReceiptItems';
import { ReceiptDetails, ReceiptDetailsProps } from './ReceiptDetails';
import { Paper, Border } from './styles';

type Props = ReceiptItemsProps & ReceiptDetailsProps;

export const Receipt = (props: Props) => (
  <Paper>
    <ReceiptItems {...props} />
    <Border />
    <ReceiptDetails {...props} />
  </Paper>
);
